import styled from "@emotion/styled";
import { FC, ButtonHTMLAttributes, MouseEvent, useState } from "react";

const StyledButton = styled("button")(
  ({ theme }) => `
    cursor: pointer;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #313c4e;
    background-position: 50%;
    background-repeat: no-repeat;
    border: 1px solid hsla(0, 0%, 100%, .667);
    border-radius: 50%;
    height: 24px;
    position: absolute;
    right: -10px;
    top: 54px;
    transition: background-color .3s ease-in-out, border-color .3s ease-in-out;
    width: 24px;
    z-index: 1;
   
    ${theme.breakpoints.down("lg")} {
        display: none;
    }

    svg {
        font-size: 18px;
    }
    
    &:before {
        content: "";
        position: absolute;
        z-index: -1;
        inset: 0;
        background-color: transparent;
        border-radius: inherit;
        opacity: 0;
        transition: opacity 0.15s ease-in-out;
        box-shadow: 0 0 0 3px #00b9ff;
    }
  
    &:after {
        content: "";
        display: block;
        height: 40px;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
        z-index: -1;
    }
    
    &.keep-sidebar + nav {
        opacity: 1;
        width: 268px;
    }
    
    &:hover {
        background-color: #00b9ff;
        border-color: #00b9ff;
    }
    
    &:active {
        &:before {
            opacity: 0.3;
        }
    }`,
);

export const ExpandButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  onClick,
  ...rest
}) => {
  const [isCaptured, setIsCaptured] = useState(false);

  const onMouseEnter = (e: MouseEvent<HTMLButtonElement>) => {
    if ((e.relatedTarget as Element)?.localName === "nav") {
      setIsCaptured(true);
    }
  };

  const onMouseLeave = () => {
    if (isCaptured) {
      setIsCaptured(false);
    }
  };

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    }
    onMouseLeave();
  };

  return (
    <StyledButton
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={isCaptured ? "keep-sidebar" : undefined}
      onClick={handleClick}
      {...rest}
    />
  );
};
